import classnames from 'classnames/bind'
import { Text } from 'components/typo'
import Link from 'components/shared/Link'

import typo from 'components/typo/typography.module.scss'
import styles from './styles.module.scss'

const css = Object.assign({}, styles, typo)

const cx = classnames.bind(css)

export default function BlogNavDropdown({
  className,
  items,
  category,
  onMouseLeave
}) {
  
  return (
    <div className={cx(css.Dropdown, className)} onMouseLeave={onMouseLeave}>
      <ul className={css.MenuLinks}>
        {items?.map((item) => (
          <li key={item.slug} className={css.MenuLink}>
            <Link href={`/blog/categories/${category}/${item.slug}`}>
              <Text className={css.DropdownItemMenu} size="smaller">{item.name}</Text>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
